import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { object } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import { HANDLE_NAMES } from '../../useResizeHandles'

// Each handle needs its own accessible name so screen readers can tell them apart.
const LABEL_KEYS = {
  'top-left': 'viewerSidebar.enhance.variations.window.resizeTopLeft',
  'top-right': 'viewerSidebar.enhance.variations.window.resizeTopRight',
  'bottom-left': 'viewerSidebar.enhance.variations.window.resizeBottomLeft',
  left: 'viewerSidebar.enhance.variations.window.resizeLeft',
  right: 'viewerSidebar.enhance.variations.window.resizeRight',
  bottom: 'viewerSidebar.enhance.variations.window.resizeBottom',
}

// Browsers only offer a resize handle at the bottom-right; the other corners and
// the edges are custom.
function ResizeHandles({ handlers }) {
  const t = useTranslation()

  return HANDLE_NAMES.map(handle => (
    <span
      key={handle}
      className={classnames('detached-window__resize', `detached-window__resize--${handle}`)}
      role="button"
      tabIndex={0}
      aria-label={t(LABEL_KEYS[handle])}
      {...handlers[handle]}
    />
  ))
}

ResizeHandles.propTypes = {
  handlers: object.isRequired,
}

export default memo(ResizeHandles)
